module.exports = __webpack_public_path__ + "static/media/sophisticated-color-pallete.a4a97609.png";